import PropTypes from 'prop-types'

const Icons = ({ iconName, stroke }) => {
  const allIcons = {
    message: (
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M53.9376 32.37V44.37C53.9376 45.15 53.9076 45.9 53.8176 46.62C53.1276 54.72 48.3576 58.74 39.5676 58.74H38.3676C37.6176 58.74 36.8975 59.1 36.4475 59.7L32.8476 64.5C31.2576 66.63 28.6776 66.63 27.0876 64.5L23.4875 59.7C23.0975 59.19 22.2276 58.74 21.5676 58.74H20.3676C10.7976 58.74 5.99756 56.37 5.99756 44.37V32.37C5.99756 23.58 10.0476 18.81 18.1176 18.12C18.8376 18.03 19.5876 18 20.3676 18H39.5676C49.1376 18 53.9376 22.8 53.9376 32.37Z"
          fill="white"
        />
        <path
          d="M29.9751 42C28.2951 42 26.9751 40.65 26.9751 39C26.9751 37.35 28.3251 36 29.9751 36C31.6251 36 32.9751 37.35 32.9751 39C32.9751 40.65 31.6551 42 29.9751 42Z"
          fill="white"
        />
        <path
          d="M40.4766 42C38.7966 42 37.4766 40.65 37.4766 39C37.4766 37.35 38.8266 36 40.4766 36C42.1266 36 43.4766 37.35 43.4766 39C43.4766 40.65 42.1266 42 40.4766 42Z"
          fill="white"
        />
        <path
          d="M19.4985 42C17.8185 42 16.4985 40.65 16.4985 39C16.4985 37.35 17.8485 36 19.4985 36C21.1485 36 22.4985 37.35 22.4985 39C22.4985 40.65 21.1485 42 19.4985 42Z"
          fill="white"
        />
        <path
          d="M65.9396 20.3694V32.3694C65.9396 41.1894 61.8896 45.9294 53.8196 46.6194C53.9096 45.8994 53.9396 45.1494 53.9396 44.3694V32.3694C53.9396 22.7994 49.1396 17.9994 39.5696 17.9994H20.3696C19.5896 17.9994 18.8396 18.0294 18.1196 18.1194C18.8096 10.0494 23.5796 5.99939 32.3696 5.99939H51.5696C61.1396 5.99939 65.9396 10.7994 65.9396 20.3694Z"
          fill="white"
        />
      </svg>
    ),
    website: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.65006 20.91C7.62006 20.91 7.58006 20.93 7.55006 20.93C5.61006 19.97 4.03006 18.38 3.06006 16.44C3.06006 16.41 3.08006 16.37 3.08006 16.34C4.30006 16.7 5.56006 16.97 6.81006 17.18C7.03006 18.44 7.29006 19.69 7.65006 20.91Z"
          fill="#155EEF"
        />
        <path
          d="M20.94 16.45C19.95 18.44 18.3 20.05 16.29 21.02C16.67 19.75 16.99 18.47 17.2 17.18C18.46 16.97 19.7 16.7 20.92 16.34C20.91 16.38 20.94 16.42 20.94 16.45Z"
          fill="#155EEF"
        />
        <path
          d="M21.02 7.70998C19.76 7.32998 18.49 7.01998 17.2 6.79998C16.99 5.50998 16.68 4.22998 16.29 2.97998C18.36 3.96998 20.03 5.63998 21.02 7.70998Z"
          fill="#155EEF"
        />
        <path
          d="M7.64998 3.09C7.28998 4.31 7.02998 5.55 6.81998 6.81C5.52998 7.01 4.24998 7.33 2.97998 7.71C3.94998 5.7 5.55998 4.05 7.54998 3.06C7.57998 3.06 7.61998 3.09 7.64998 3.09Z"
          fill="#155EEF"
        />
        <path
          d="M15.4898 6.59C13.1698 6.33 10.8298 6.33 8.50977 6.59C8.75977 5.22 9.07977 3.85 9.52977 2.53C9.54977 2.45 9.53977 2.39 9.54977 2.31C10.3398 2.12 11.1498 2 11.9998 2C12.8398 2 13.6598 2.12 14.4398 2.31C14.4498 2.39 14.4498 2.45 14.4698 2.53C14.9198 3.86 15.2398 5.22 15.4898 6.59Z"
          fill="#155EEF"
        />
        <path
          d="M6.59 15.49C5.21 15.24 3.85 14.92 2.53 14.47C2.45 14.45 2.39 14.46 2.31 14.45C2.12 13.66 2 12.85 2 12C2 11.16 2.12 10.34 2.31 9.56001C2.39 9.55001 2.45 9.55001 2.53 9.53001C3.86 9.09001 5.21 8.76001 6.59 8.51001C6.34 10.83 6.34 13.17 6.59 15.49Z"
          fill="#155EEF"
        />
        <path
          d="M22.0002 12C22.0002 12.85 21.8802 13.66 21.6902 14.45C21.6102 14.46 21.5502 14.45 21.4702 14.47C20.1402 14.91 18.7802 15.24 17.4102 15.49C17.6702 13.17 17.6702 10.83 17.4102 8.51001C18.7802 8.76001 20.1502 9.08001 21.4702 9.53001C21.5502 9.55001 21.6102 9.56001 21.6902 9.56001C21.8802 10.35 22.0002 11.16 22.0002 12Z"
          fill="#155EEF"
        />
        <path
          d="M15.4898 17.41C15.2398 18.79 14.9198 20.15 14.4698 21.47C14.4498 21.55 14.4498 21.61 14.4398 21.69C13.6598 21.88 12.8398 22 11.9998 22C11.1498 22 10.3398 21.88 9.54977 21.69C9.53977 21.61 9.54977 21.55 9.52977 21.47C9.08977 20.14 8.75977 18.79 8.50977 17.41C9.66977 17.54 10.8298 17.63 11.9998 17.63C13.1698 17.63 14.3398 17.54 15.4898 17.41Z"
          fill="#155EEF"
        />
        <path
          d="M15.7633 15.7633C13.2622 16.0789 10.7378 16.0789 8.23667 15.7633C7.92111 13.2622 7.92111 10.7378 8.23667 8.23667C10.7378 7.92111 13.2622 7.92111 15.7633 8.23667C16.0789 10.7378 16.0789 13.2622 15.7633 15.7633Z"
          fill="#155EEF"
        />
      </svg>
    ),
    stage: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.23 16.6001C20.23 16.5701 20.25 16.5401 20.25 16.5001V7.00005C20.25 5.48005 19.02 4.25005 17.5 4.25005H13.57L14.98 3.08005C15.3 2.81005 15.34 2.34005 15.08 2.02005C14.81 1.70005 14.34 1.66005 14.02 1.92005L11.02 4.42005C10.85 4.56005 10.75 4.77005 10.75 5.00005C10.75 5.23005 10.85 5.43005 11.02 5.58005L14.02 8.08005C14.16 8.20005 14.33 8.25005 14.5 8.25005C14.71 8.25005 14.93 8.16005 15.08 7.98005C15.35 7.66005 15.3 7.19005 14.98 6.92005L13.57 5.75005H17.5C18.19 5.75005 18.75 6.31005 18.75 7.00005V16.5001C18.75 16.5401 18.77 16.5701 18.77 16.6001C17.47 16.9301 16.5 18.1001 16.5 19.5001C16.5 21.1601 17.84 22.5001 19.5 22.5001C21.16 22.5001 22.5 21.1601 22.5 19.5001C22.5 18.1001 21.53 16.9301 20.23 16.6001Z"
          fill="white"
        />
        <path
          d="M13.98 19.42L10.98 16.92C10.66 16.65 10.19 16.7 9.92 17.02C9.65 17.34 9.7 17.81 10.02 18.08L11.43 19.25H7.5C6.81 19.25 6.25 18.69 6.25 18V8.5C6.25 8.46 6.23 8.43 6.23 8.4C7.53 8.07 8.5 6.9 8.5 5.5C8.5 3.84 7.16 2.5 5.5 2.5C3.84 2.5 2.5 3.84 2.5 5.5C2.5 6.9 3.47 8.07 4.77 8.4C4.77 8.43 4.75 8.46 4.75 8.5V18C4.75 19.52 5.98 20.75 7.5 20.75H11.43L10.02 21.92C9.7 22.19 9.66 22.66 9.92 22.98C10.07 23.16 10.28 23.25 10.5 23.25C10.67 23.25 10.84 23.19 10.98 23.08L13.98 20.58C14.15 20.44 14.25 20.23 14.25 20C14.25 19.77 14.15 19.57 13.98 19.42Z"
          fill="white"
        />
      </svg>
    ),
    users: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z"
          fill="white"
        />
        <path
          d="M14.08 14.15C11.29 12.29 6.73996 12.29 3.92996 14.15C2.65996 15 1.95996 16.15 1.95996 17.38C1.95996 18.61 2.65996 19.75 3.91996 20.59C5.31996 21.53 7.15996 22 8.99996 22C10.84 22 12.68 21.53 14.08 20.59C15.34 19.74 16.04 18.6 16.04 17.36C16.03 16.13 15.34 14.99 14.08 14.15Z"
          fill="white"
        />
        <path
          d="M19.9899 7.33998C20.1499 9.27998 18.7699 10.98 16.8599 11.21C16.8499 11.21 16.8499 11.21 16.8399 11.21H16.8099C16.7499 11.21 16.6899 11.21 16.6399 11.23C15.6699 11.28 14.7799 10.97 14.1099 10.4C15.1399 9.47998 15.7299 8.09998 15.6099 6.59998C15.5399 5.78998 15.2599 5.04998 14.8399 4.41998C15.2199 4.22998 15.6599 4.10998 16.1099 4.06998C18.0699 3.89998 19.8199 5.35998 19.9899 7.33998Z"
          fill="white"
        />
        <path
          d="M21.9902 16.59C21.9102 17.56 21.2902 18.4 20.2502 18.97C19.2502 19.52 17.9902 19.78 16.7402 19.75C17.4602 19.1 17.8802 18.29 17.9602 17.43C18.0602 16.19 17.4702 15 16.2902 14.05C15.6202 13.52 14.8402 13.1 13.9902 12.79C16.2002 12.15 18.9802 12.58 20.6902 13.96C21.6102 14.7 22.0802 15.63 21.9902 16.59Z"
          fill="white"
        />
      </svg>
    ),
    twitter: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.29 18.251C13.837 18.251 17.965 11.998 17.965 6.57596C17.965 6.39796 17.965 6.22096 17.953 6.04596C18.7562 5.46448 19.4493 4.74457 20 3.91996C19.2511 4.25196 18.4566 4.46972 17.643 4.56596C18.4996 4.05302 19.1408 3.24631 19.447 2.29596C18.6417 2.77384 17.7607 3.11069 16.842 3.29196C16.2234 2.63372 15.405 2.19779 14.5136 2.05166C13.6222 1.90553 12.7075 2.05736 11.9111 2.48363C11.1147 2.9099 10.4811 3.58683 10.1083 4.40962C9.7355 5.2324 9.64437 6.15514 9.849 7.03496C8.21759 6.9532 6.6216 6.52928 5.16465 5.79073C3.70769 5.05217 2.42233 4.01548 1.392 2.74796C0.867318 3.65116 0.706589 4.72038 0.942536 5.73792C1.17848 6.75547 1.79337 7.64483 2.662 8.22496C2.00926 8.20602 1.37065 8.03042 0.8 7.71296V7.76496C0.800389 8.71225 1.1284 9.63026 1.7284 10.3633C2.3284 11.0964 3.16347 11.5993 4.092 11.787C3.48781 11.9517 2.85389 11.9756 2.239 11.857C2.50116 12.6724 3.01168 13.3856 3.69913 13.8966C4.38658 14.4076 5.21657 14.6909 6.073 14.707C5.22212 15.3755 4.24779 15.8698 3.20573 16.1615C2.16367 16.4532 1.07432 16.5366 0 16.407C1.8766 17.6113 4.06019 18.2501 6.29 18.247"
          fill="#D0D5DD"
        />
      </svg>
    ),
    linkedin: (
      <svg
        className="w-[20px] h-[20px]"
        aria-hidden="true"
        fill="#D0D5DD"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
          clipRule="evenodd"
        />
      </svg>
    ),
  }
  return allIcons[iconName]
}

Icons.propTypes = {
  iconName: PropTypes.string.isRequired,
}

export default Icons
